const mapLabels = {
    ContentNoLimits: {
        default: [
            {
                continent: 'Africa',
                creator_count: '420k+',
                pos_x: 700,
                pos_y: 540
            },
            {
                continent: 'Asia',
                creator_count: '2.1m+',
                pos_x: 940,
                pos_y: 350
            },
            {
                continent: 'Australia',
                creator_count: '476k+',
                pos_x: 1148,
                pos_y: 700
            },
            {
                continent: 'Europe',
                creator_count: '3.22m+',
                pos_x: 700,
                pos_y: 325
            },
            {
                continent: 'North America',
                creator_count: '5.6m+',
                pos_x: 210,
                pos_y: 370
            },
            {
                continent: 'South America',
                creator_count: '2.8m+',
                pos_x: 360,
                pos_y: 670
            }
        ],
        small: [
            {
                continent: 'Africa',
                creator_count: '420k+',
                pos_x: 430,
                pos_y: 300
            },
            {
                continent: 'Asia',
                creator_count: '2.1m+',
                pos_x: 570,
                pos_y: 190
            },
            {
                continent: 'Australia',
                creator_count: '476k+',
                pos_x: 722,
                pos_y: 390
            },
            {
                continent: 'Europe',
                creator_count: '3.22m+',
                pos_x: 422,
                pos_y: 175
            },
            {
                continent: 'North America',
                creator_count: '5.6m+',
                pos_x: 120,
                pos_y: 210
            },
            {
                continent: 'South America',
                creator_count: '2.8m+',
                pos_x: 220,
                pos_y: 352
            }
        ],
        medium: [
            {
                continent: 'Africa',
                creator_count: '420k+',
                pos_x: 540,
                pos_y: 390
            },
            {
                continent: 'Asia',
                creator_count: '2.1m+',
                pos_x: 720,
                pos_y: 230
            },
            {
                continent: 'Australia',
                creator_count: '476k+',
                pos_x: 875,
                pos_y: 485
            },
            {
                continent: 'Europe',
                creator_count: '3.22m+',
                pos_x: 525,
                pos_y: 220
            },
            {
                continent: 'North America',
                creator_count: '5.6m+',
                pos_x: 150,
                pos_y: 250
            },
            {
                continent: 'South America',
                creator_count: '2.8m+',
                pos_x: 270,
                pos_y: 450
            }
        ]
    }
};

export default mapLabels;



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/map_labels.js